import { useNavigate } from 'react-router-dom';

export const useCustomAlarmsNavigation = () => {
    const navigate = useNavigate();

    const navigateToCreate = () => {
        navigate('custom-notifications/new');
    };

    const navigateToEdit = (id: string) => {
        navigate(`custom-notifications/${id}`);
    };

    return {
        navigateToCreate,
        navigateToEdit,
    };
};
